import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    goodOrders: [],
    goodOrderFilters: [],
    goodOrderStatuses: [],
    goodOrder: [],
    goodOrderItems: [],
    goodOrderProducts: [],
    syncItems: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
